export default __webpack_public_path__ + "static/media/faca_parte_da_equipe.f456bc04.png";